// ** React Imports
import { Fragment, lazy } from "react"
import { Navigate } from "react-router-dom"
// ** Layouts
import BlankLayout from "@layouts/BlankLayout"
import VerticalLayout from "@src/layouts/VerticalLayout"
import HorizontalLayout from "@src/layouts/HorizontalLayout"
import LayoutWrapper from "@src/@core/layouts/components/layout-wrapper"

// ** Route Components
import PublicRoute from "@components/routes/PublicRoute"

// ** Utils
import { isObjEmpty, isUserLoggedIn } from "@utils"
import VerificationDetails from "../../views/Dashboard/VerificationDetails"


const getLayout = {
  blank: <BlankLayout />,
  vertical: <VerticalLayout />,
  horizontal: <HorizontalLayout />
}

// ** Document title
// const TemplateTitle = "%s - Vuexy React Admin Template"
const TemplateTitle = 'Publications'
// ** Default Route
let DefaultRoute = "/search"

// const Dashboard = lazy(() => import("../../views/Dashboard"))
// const CustomerDashboard = lazy(() => import("../../views/Dashboard/CustomerDashboard"))
// const EmployeeDashboard = lazy(() => import("../../views/Dashboard/EmployeeDashboard"))
const RLMDashboard = lazy(() => import("../../views/Dashboard/RLMDashboard"))
// const QB_Dashboard = lazy(() => import("../../views/Dashboard/QB_Reports"))

const UserManagement = lazy(() => import("../../views/Dashboard/UserManagement"))
// const Login = lazy(() => import("../../views/Login"))
// const Register = lazy(() => import("../../views/Register"))
// const ForgotPassword = lazy(() => import("../../views/ForgotPassword"))
const Error = lazy(() => import("../../views/Pages/Error"))
const Unauthorized = lazy(() => import("../../views/Pages/Unauthorized"))
// const Workorder = lazy(() => import("../../views/Workorder"))
const MyProfile = lazy(() => import("../../views/MyProfile"))
const PageRefresh = lazy(() => import("../../views/PageRefresh"))
const RLM = lazy(() => import("../../views/Components/RLM"))
const RLMMenu = lazy(() => import("../../views/Components/RLMHome"))
const Library = lazy(() => import("../../views/Components/Library"))
const IMOConventions = lazy(() => import("../../views/Components/IMOConventions"))
// const IMORegistry = lazy(() => import("../../views/Components/IMORegistry"))
const RLMContactUs = lazy(() => import("../../views/Components/RLMContactUs"))
let Routes = []

const getRouteMeta = (route) => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta }
    } else {
      return {}
    }
  }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = []
  if (isUserLoggedIn()) {
    if (JSON.parse(isUserLoggedIn())?.isEmployee) {
      let sessionRoute = sessionStorage.getItem('UrlPath')
      const enableRoute = false
      // const userData = JSON.parse(localStorage.getItem('userData'))
      // const userRoles = userData && userData.userRoles
      // if (userRoles) {
      //   const findRole = userRoles.find(find => (find.rId === 1 || find.rId === 6 || find.rId === 7))
      //   if (findRole) {
      //     enableRoute = true
      //   }
      // }
      if (sessionRoute === '/Unauthorized') {
        if (userRoles && userRoles.length > 0) {
          sessionRoute = '/Publications'
        }
      }

      DefaultRoute = sessionRoute ? sessionRoute : '/Publications'

      // **Employee Merge Routes
      if (enableRoute) {
        const remployeeRoutes = [


          // {
          //   path: "/search",
          //   element: <EmployeeDashboard />
          // },
          // // {
          // //   path: "/dashboard",
          // //   element: <RLMDashboard />
          // // },
          // {
          //   path: "/QB_Reports",
          //   element: <QB_Dashboard />
          // },
          // {
          //   path: "/role-management",
          //   element: <UserManagement />
          // },
          // {
          //   path: "/:catCode/:typeCode/save",
          //   element: <Workorder />
          // },
          // {
          //   path: "/:catCode/:typeCode/:woId",
          //   element: <Workorder />
          // },
          {
            path: "/Publications",
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              }
            ]
          },
          // {
          //   path: "/registry",
          //   element: <IMORegistry />
          // },
          // {
          //   path: "/my-profile",
          //   element: <MyProfile />
          // },
          {
            path: '/Unauthorized',
            element: <Unauthorized />
          },
          {
            path: "/",
            // index: true,
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              },
              {
                path: "/my-profile",
                element: <MyProfile />
              },
              {
                path: '/pageRefresh',
                element: <PageRefresh />
              }
            ]
          },
          {
            path: "*",
            element: <Error />
          }
        ]
        Routes = remployeeRoutes
      } else {
        const employeeRoutes = [

          // {
          //   path: "/search",
          //   element: <EmployeeDashboard />
          // },
          // {
          //   path: "/dashboard",
          //   element: <RLMDashboard />
          // },
          // {
          //   path: "/:catCode/:typeCode/save",
          //   element: <Workorder />
          // },
          // {
          //   path: "/:catCode/:typeCode/:woId",
          //   element: <Workorder />
          // },
          {
            path: "/Publications",
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                index: true,
                element: <Navigate to="home" replace />
              },
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              }
            ]
          },
          // {
          //   path: "/registry",
          //   element: <IMORegistry />
          // },
          // {
          //   path: "/my-profile",
          //   element: <MyProfile />
          // },
          // {
          //   path: '/pageRefresh',
          //   element: <PageRefresh />
          // },
          {
            path: '/Unauthorized',
            element: <Unauthorized />
          },
          {
            path: "/",
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                index: true,
                element: <Navigate to="home" replace />
              },
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              },
              {
                path: "/my-profile",
                element: <MyProfile />
              },
              {
                path: '/pageRefresh',
                element: <PageRefresh />
              }
            ]
            // index: true,
            // element: <Navigate replace to={DefaultRoute} />
          },
          {
            path: "*",
            element: <Error />
          }
        ]
        Routes = employeeRoutes
      }
    } else {
      // **Customer Merge Routes
      let sessionRoute = sessionStorage.getItem('UrlPath')
      const userData = JSON.parse(localStorage.getItem('userData'))
      const companies = userData && userData.companies
      if (sessionRoute === '/Unauthorized') {
        if (companies && companies.length > 0) {
          sessionRoute = '/Publications'
        }
      }
      DefaultRoute = sessionRoute ? sessionRoute : '/Publications'
      const userAgents = JSON.parse(isUserLoggedIn()).userData?.userAgents

      let customerRoutes = []
      if (userAgents?.length) {
        customerRoutes = [

          // {
          //   path: "/search",
          //   element: <CustomerDashboard />
          // },
          // // {
          // //   path: "/dashboard",
          // //   element: <RLMDashboard />
          // // },
          // {
          //   path: "/:catCode/:typeCode/save",
          //   element: <Workorder />
          // },
          // {
          //   path: "/:catCode/:typeCode/:woId",
          //   element: <Workorder />
          // },
          {
            path: "/Publications",
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              }
            ]
          },
          // {
          //   path: "/my-profile",
          //   element: <MyProfile />
          // },
          // {
          //   path: '/pageRefresh',
          //   element: <PageRefresh />
          // },
          {
            path: '/Unauthorized',
            element: <Unauthorized />
          }, {
            path: "/",
            // index: true,
            // element: <Navigate replace to={DefaultRoute} />
            element: <RLM />, // Parent Route for RLM
            children: [
              {
                index: true,
                element: <Navigate to="home" replace />
              },
              {
                path: "home",
                element: <RLMMenu /> // Sub-route under /RLM
              },
              {
                path: "library",
                element: <Library /> // Sub-route under /RLM
              },
              {
                path: "imo-conventions",
                element: <IMOConventions /> // Sub-route under /RLM
              },
              {
                path: "subscriptions",
                element: <RLMDashboard /> // Sub-route under /RLM
              },
              {
                path: "contact-us",
                element: <RLMContactUs /> // Sub-route under /RLM
              },
              {
                path: "/my-profile",
                element: <MyProfile />
              },
              {
                path: '/pageRefresh',
                element: <PageRefresh />
              }
            ]
          },
          {
            path: "*",
            element: <Error />
          }
        ]
      } else {
        DefaultRoute = '/verificationDetails'
        customerRoutes = [
          {
            path: "/",
            index: true,
            element: <Navigate replace to={DefaultRoute} />
          },
          {
            path: "/my-profile",
            element: <MyProfile />
          },
          {
            path: "/verificationDetails",
            element: <VerificationDetails />
          },
          {
            path: "*",
            element: <Error />
          }
        ]
      }
      Routes = customerRoutes
    }
  }
  if (Routes) {
    Routes.filter((route) => {
      let isBlank = false
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) &&
          defaultLayout === layout)
      ) {
        const RouteTag = PublicRoute

        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === "blank" ? (isBlank = true) : (isBlank = false)
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            isObjEmpty(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
              LayoutWrapper
              : Fragment

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          )
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route)
      }
      return LayoutRoutes
    })
  }
  return LayoutRoutes
}

const getRoutes = (layout) => {
  const defaultLayout = layout || "vertical"
  const layouts = ["vertical", "horizontal", "blank"]

  const AllRoutes = []

  layouts.forEach((layoutItem) => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

    AllRoutes.push({
      path: "/",
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    })
  })
  return AllRoutes
}

export { DefaultRoute, TemplateTitle, Routes, getRoutes }
